export default {
  SHARING: 'sharing',
  BOOKING: 'booking',
};
